import { getCountryCodeAndRetailerId } from '../utils';

const configuration = require('Config');
let countryCode = getCountryCodeAndRetailerId();
let retailerId;
/* search functionalites from frontside */
let non_latin_language = false;

if(countryCode === 'uk' || countryCode === '') {
    retailerId = 446;
    countryCode = 'uk';
} else if (countryCode === 'us') {
    retailerId = 181;
} else if( countryCode === "th" ) {
    retailerId = 446;
    non_latin_language = true;
} else if( countryCode === "mx" ) {
    retailerId = 1686;
} else if( countryCode === "liz" ) {
    retailerId = 1691;
}

export const config = {
    api: configuration.baseUrl + configuration.languageCode[countryCode] + configuration.api,
    medias: configuration.baseUrl + configuration.medias,
    videos: countryCode === "us" ? '' : configuration.baseUrl + configuration.medias ,
    test: configuration.baseUrl + configuration.languageCode[countryCode] + configuration.test,
    retailerId: retailerId,
    countryCode: countryCode,
    non_latin_language: non_latin_language,
    googleAnalytisUserId: "G-QN2TNWNQ7W"
}
